import { render, staticRenderFns } from "./EditOrganizationInterviews.vue?vue&type=template&id=2245bc18&scoped=true"
import script from "./EditOrganizationInterviews.vue?vue&type=script&lang=js"
export * from "./EditOrganizationInterviews.vue?vue&type=script&lang=js"
import style0 from "./EditOrganizationInterviews.vue?vue&type=style&index=0&id=2245bc18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245bc18",
  null
  
)

export default component.exports